import { AccountNavigator } from '@/src/navigation/AccountNavigator'

export default function AccountLayout() {
  return <AccountNavigator />
}
